import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import axios from "../../api/axiosinstance";

import { showError, showSuccess } from "../../utils/toastUtils";

import { motion } from "framer-motion";
import PageTransition from "../../components/PageTransition";
import axiosInstance from "../../api/axiosinstance";

import { useNavigate } from "react-router-dom";

/* ================= RESPONSIVE HOOK ================= */
// Simple hook jo window width track karta hai, taaki hum
// breakpoints ke hisaab se styles switch kar saken.
function useWindowWidth() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}

function AgreementPaymentView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [agreementData, setAgreementData] = useState(null);

  const [loading, setLoading] = useState(false);

  const [selectedPayment, setSelectedPayment] = useState("full");

  const width = useWindowWidth();
  // 0-640    -> phone (fully stacked)
  // 641-1024 -> tablet (still side-by-side, narrower)
  // 1025+    -> desktop
  const isMobile = width <= 640;
  const isTablet = width > 640 && width <= 1024;

  /* ================= FETCH ================= */

  useEffect(() => {
    if (id) {
      trackPaymentPage();
    }
  }, [id]);

  const trackPaymentPage = async () => {
    try {
      await axiosInstance.post("/client-journey/track", {
        agreementId: id,

        step: "payment_page_opened",

        page: window.location.pathname,

        description: "Client opened payment page",
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const fetchAgreement = async () => {
      try {
        const res = await axios.get(`/service-agreement/by-id/${id}`);

        const agreement = res?.data || {};

        console.log("AGREEMENT RESPONSE", agreement);

        setAgreementData(agreement);
      } catch (err) {
        console.log(err);

        showError("Failed to load agreement");
      }
    };

    fetchAgreement();
  }, [id]);

  /* ================= VALUES ================= */

  const additionalAmount = (agreementData?.additionalPayments || []).reduce(
    (acc, item) => acc + Number(item.amount || 0),
    0,
  );

  const totalAmount = Number(agreementData?.amount || 0);

  const alreadyPaid = Number(agreementData?.paidAmount || 0);

  const pendingAmount = Math.max(totalAmount - alreadyPaid, 0);
  const payableAmount =
    selectedPayment === "full" ? pendingAmount : Math.floor(pendingAmount / 2);

  /* ================= PAYMENT ================= */

  const handlePayment = async () => {
    try {
      setLoading(true);

      await axiosInstance.post("/client-journey/track", {
        agreementId: id,

        step: "payment_initiated",

        page: window.location.pathname,

        description: `Client started ${selectedPayment} payment`,
      });

      const res = await axios.post("/payment/create-order", {
        agreementId: id,
        paymentType: selectedPayment,
      });

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,

        amount: res.amount,

        currency: res.currency,

        order_id: res.orderId,

        name: "Axepert Services",

        description:
          selectedPayment === "full" ? "Full Payment" : "Partial Payment",

        handler: async function (response) {
          try {
            const verifyRes = await axios.post("/payment/verify", {
              razorpay_order_id: response.razorpay_order_id,

              razorpay_payment_id: response.razorpay_payment_id,

              razorpay_signature: response.razorpay_signature,
            });

            console.log("VERIFY RESPONSE", verifyRes);

            if (verifyRes?.success === true) {
              showSuccess("Payment Successful");

              setTimeout(() => {
                navigate(`/payment-success/${id}`);
              }, 1200);
            } else {
              showError("Payment verification failed");

              setTimeout(() => {
                navigate(`/payment-failed/${id}`);
              }, 1200);
            }
          } catch (err) {
            console.log(err);

            showError("Payment verification failed");

            setTimeout(() => {
              navigate(`/payment-failed/${id}`);
            }, 1200);
          }
        },

        theme: {
          color: "#5a140c",
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.open();
    } catch (err) {
      console.log(err);

      showError("Payment failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageTransition>
      <div
        style={{
          minHeight: "100vh",
          background: "#f4f0ec",
          padding: isMobile ? "16px 10px" : isTablet ? "24px 16px" : "40px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1350px",
            margin: "0 auto",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "18px" : isTablet ? "20px" : "35px",
            alignItems: isMobile ? "stretch" : "flex-start",
          }}
        >
          {/* LEFT PANEL */}

          <div
            style={{
              width: isMobile ? "100%" : isTablet ? "230px" : "340px",
              minWidth: isMobile ? "100%" : isTablet ? "230px" : "340px",
              background: "#5a140c",
              borderRadius: isMobile ? "20px" : "28px",
              padding: isMobile ? "24px 22px" : isTablet ? "28px 22px" : "40px 35px",
              color: "#fff",
              position: isMobile ? "relative" : "sticky",
              top: "20px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: isMobile ? "140px" : "220px",
                height: isMobile ? "140px" : "220px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.05)",
                top: "-80px",
                right: "-80px",
              }}
            />

            <img
              src="/assets/img/whitelogo.png"
              alt=""
              style={{
                width: isMobile ? "100px" : isTablet ? "110px" : "130px",
                marginBottom: isMobile ? "20px" : isTablet ? "26px" : "35px",
              }}
            />

            <h1
              style={{
                fontSize: isMobile ? "28px" : isTablet ? "34px" : "42px",
                lineHeight: isMobile ? "36px" : isTablet ? "44px" : "52px",
                fontWeight: "700",
                marginBottom: isMobile ? "16px" : "25px",
                color: "#fff",
              }}
            >
              SERVICE
              <br />
              AGREEMENT
            </h1>

            <div
              style={{
                width: "90px",
                height: "3px",
                background: "#ffffff",
                marginBottom: isMobile ? "18px" : "30px",
              }}
            />

            <p
              style={{
                lineHeight: isMobile ? "24px" : "32px",
                color: "rgba(255,255,255,0.82)",
                fontSize: isMobile ? "13px" : "15px",
              }}
            >
              Please review all terms carefully before proceeding further. This
              agreement becomes effective once you verify the OTP and complete
              payment.
            </p>

            {/* STEPS */}

            <div
              style={{
                marginTop: isMobile ? "24px" : "45px",
                display: "flex",
                flexDirection: isMobile ? "row" : "column",
                flexWrap: "wrap",
                gap: isMobile ? "12px" : "18px",
              }}
            >
              <div
                style={{
                  flex: isMobile ? "1 1 auto" : "unset",
                  minWidth: isMobile ? "90px" : "auto",
                  background: "rgba(255,255,255,0.12)",

                  border: "1px solid rgba(255,255,255,0.08)",

                  padding: isMobile ? "10px 12px" : "18px",

                  borderRadius: isMobile ? "14px" : "18px",
                }}
              >
                <div
                  style={{
                    fontSize: isMobile ? "11px" : "13px",
                    opacity: 0.7,
                    marginBottom: isMobile ? "4px" : "8px",
                  }}
                >
                  Step 1
                </div>

                <div
                  style={{
                    fontWeight: "600",
                    fontSize: isMobile ? "13px" : "16px",
                  }}
                >
                  Review Agreement
                </div>
              </div>

              <div
                style={{
                  flex: isMobile ? "1 1 auto" : "unset",
                  minWidth: isMobile ? "90px" : "auto",
                  background: "rgba(255,255,255,0.12)",

                  border: "1px solid rgba(255,255,255,0.08)",

                  padding: isMobile ? "10px 12px" : "18px",

                  borderRadius: isMobile ? "14px" : "18px",
                }}
              >
                <div
                  style={{
                    fontSize: isMobile ? "11px" : "13px",
                    opacity: 0.7,
                    marginBottom: isMobile ? "4px" : "8px",
                  }}
                >
                  Step 2
                </div>

                <div
                  style={{
                    fontWeight: "600",
                    fontSize: isMobile ? "13px" : "16px",
                  }}
                >
                  OTP Verification
                </div>
              </div>

              <div
                style={{
                  flex: isMobile ? "1 1 auto" : "unset",
                  minWidth: isMobile ? "90px" : "auto",
                  background: "rgba(255,255,255,0.22)",

                  border: "1px solid rgba(255,255,255,0.15)",

                  boxShadow: "0 0 20px rgba(255,255,255,0.08)",

                  padding: isMobile ? "10px 12px" : "18px",

                  borderRadius: isMobile ? "14px" : "18px",
                }}
              >
                <div
                  style={{
                    fontSize: isMobile ? "11px" : "13px",
                    opacity: 0.7,
                    marginBottom: isMobile ? "4px" : "8px",
                  }}
                >
                  Step 3
                </div>

                <div
                  style={{
                    fontWeight: "600",
                    fontSize: isMobile ? "13px" : "16px",
                  }}
                >
                  Payment Process
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}

          <div
            style={{
              flex: 1,
              width: isMobile ? "100%" : "auto",
              minWidth: 0,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: isMobile ? "18px" : "24px",
                padding: isMobile ? "16px" : isTablet ? "24px" : "35px",
                border: "1px solid #eaded8",
              }}
            >
              <div
                style={{
                  display: isMobile || isTablet ? "flex" : "grid",
                  flexDirection: isMobile || isTablet ? "column" : undefined,
                  gridTemplateColumns:
                    isMobile || isTablet ? undefined : "1.4fr 1fr",
                  gap: isMobile ? "18px" : isTablet ? "22px" : "30px",
                }}
              >
                {/* LEFT */}

                <div>
                  {/* INCLUDED MODULES */}

                  <motion.div
                    initial={{
                      opacity: 0,
                      x: 100,
                    }}
                    animate={{
                      opacity: 1,
                      x: 0,
                    }}
                    transition={{
                      duration: 0.6,
                    }}
                    style={{
                      border: "1px solid #eaded8",
                      borderRadius: isMobile ? "16px" : "22px",
                      padding: isMobile ? "18px" : "28px",
                      marginBottom: isMobile ? "18px" : "28px",
                      background: "#fffdfb",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginBottom: isMobile ? "16px" : "25px",
                      }}
                    >
                      <h2
                        style={{
                          color: "#5a140c",
                          fontSize: isMobile ? "19px" : "25px",
                          fontWeight: "700",
                          margin: 0,
                        }}
                      >
                        Included Modules
                      </h2>

                      <div
                        style={{
                          background: "#5a140c",
                          color: "#fff",
                          padding: isMobile ? "6px 12px" : "8px 14px",
                          borderRadius: "30px",
                          fontSize: isMobile ? "12px" : "13px",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {agreementData?.features?.length || 0} Modules
                      </div>
                    </div>

                    {agreementData?.features?.length > 0 ? (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: isMobile
                            ? "1fr"
                            : "repeat(2,minmax(0,1fr))",
                          gap: isMobile ? "12px" : "16px",
                        }}
                      >
                        {agreementData?.features?.map((item, index) => (
                          <div
                            key={index}
                            style={{
                              border: "1px solid #eee",
                              borderRadius: "14px",
                              padding: isMobile ? "12px" : "16px",
                              background: "#fff",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "12px",
                            }}
                          >
                            <div
                              style={{
                                width: isMobile ? "24px" : "28px",
                                height: isMobile ? "24px" : "28px",
                                minWidth: isMobile ? "24px" : "28px",
                                borderRadius: "50%",
                                background: "#5a140c",
                                color: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: isMobile ? "12px" : "14px",
                                fontWeight: "700",
                              }}
                            >
                              ✓
                            </div>

                            <div
                              style={{
                                color: "#444",
                                lineHeight: isMobile ? "22px" : "28px",
                                fontSize: isMobile ? "13px" : "15px",
                              }}
                            >
                              {item}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div
                        style={{
                          color: "#777",
                          lineHeight: "28px",
                          fontSize: isMobile ? "13px" : "15px",
                        }}
                      >
                        No modules available
                      </div>
                    )}
                  </motion.div>

                  {/* ADDITIONAL MODULES */}

                  {agreementData?.commitments?.length > 0 && (
                    <div
                      style={{
                        border: "1px solid #eaded8",
                        borderRadius: isMobile ? "16px" : "22px",
                        padding: isMobile ? "18px" : "28px",
                        background: "#fffdfb",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "10px",
                          marginBottom: isMobile ? "16px" : "25px",
                        }}
                      >
                        <h2
                          style={{
                            color: "#5a140c",
                            fontSize: isMobile ? "19px" : "25px",
                            fontWeight: "700",
                            margin: 0,
                          }}
                        >
                          Additional Modules
                        </h2>

                        <div
                          style={{
                            background: "#f3e7e3",
                            color: "#5a140c",
                            padding: isMobile ? "6px 12px" : "8px 14px",
                            borderRadius: "30px",
                            fontSize: isMobile ? "12px" : "13px",
                            fontWeight: "700",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {agreementData?.commitments?.length} Add-ons
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: isMobile ? "14px" : "20px",
                        }}
                      >
                        {agreementData?.commitments?.map((item, index) => (
                          <div
                            key={index}
                            style={{
                              border: "1px solid #eaded8",
                              borderRadius: "18px",
                              padding: isMobile ? "16px" : "22px",
                              background: "#ffffff",
                            }}
                          >
                            <div
                              style={{
                                marginBottom: isMobile ? "12px" : "18px",
                              }}
                            >
                              <div
                                style={{
                                  color: "#5a140c",
                                  fontWeight: "700",
                                  fontSize: isMobile ? "16px" : "20px",
                                  marginBottom: "8px",
                                }}
                              >
                                {item.moduleName}
                              </div>

                              <div
                                style={{
                                  color: "#666",
                                  lineHeight: isMobile ? "22px" : "28px",
                                  fontSize: isMobile ? "13px" : "15px",
                                }}
                              >
                                {item.description}
                              </div>
                            </div>

                            <div
                              style={{
                                color: "#5a140c",
                                fontWeight: "700",
                                fontSize: isMobile ? "20px" : "26px",
                              }}
                            >
                              ₹{Number(item.price || 0).toLocaleString("en-IN")}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* RIGHT — PAYMENT SUMMARY */}

                <div
                  style={{
                    border: "1px solid #eaded8",
                    borderRadius: isMobile ? "16px" : "20px",
                    padding: isMobile ? "18px" : "25px",
                    height: "fit-content",
                    background: "#fffdfb",
                    position: isMobile || isTablet ? "static" : "sticky",
                    top: "20px",
                  }}
                >
                  <h3
                    style={{
                      color: "#5a140c",
                      fontSize: isMobile ? "20px" : "28px",
                      marginBottom: isMobile ? "18px" : "25px",
                      fontWeight: "700",
                    }}
                  >
                    Payment Summary
                  </h3>

                  {/* TOTAL */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #eee",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                      fontSize: isMobile ? "13px" : "15px",
                    }}
                  >
                    <span
                      style={{
                        color: "#666",
                      }}
                    >
                      Total Amount
                    </span>

                    <strong>₹{totalAmount.toLocaleString("en-IN")}</strong>
                  </div>

                  {/* ADDITIONAL CHARGES */}

                  {additionalAmount > 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #eee",
                        paddingBottom: "16px",
                        marginBottom: "16px",
                        fontSize: isMobile ? "13px" : "15px",
                      }}
                    >
                      <span
                        style={{
                          color: "#666",
                        }}
                      >
                        Additional Charges
                      </span>

                      <strong>
                        ₹{additionalAmount.toLocaleString("en-IN")}
                      </strong>
                    </div>
                  )}

                  {/* PAYMENT TYPE */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #eee",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                      fontSize: isMobile ? "13px" : "15px",
                    }}
                  >
                    <span
                      style={{
                        color: "#666",
                      }}
                    >
                      Payment Type
                    </span>

                    <strong
                      style={{
                        color: "#5a140c",
                        textTransform: "capitalize",
                      }}
                    >
                      {selectedPayment}
                    </strong>
                  </div>

                  {/* SELECTED */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: isMobile ? "18px" : "25px",
                      fontSize: isMobile ? "13px" : "15px",
                    }}
                  >
                    <span
                      style={{
                        color: "#666",
                      }}
                    >
                      Payable Amount
                    </span>

                    <strong
                      style={{
                        color: "#5a140c",
                        fontSize: isMobile ? "19px" : "24px",
                      }}
                    >
                      ₹{payableAmount.toLocaleString("en-IN")}
                    </strong>
                  </div>

                  {/* BUTTONS */}

                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginBottom: isMobile ? "16px" : "20px",
                    }}
                  >
                    <button
                      onClick={() => setSelectedPayment("partial")}
                      style={{
                        flex: 1,
                        height: isMobile ? "44px" : "48px",
                        borderRadius: "10px",
                        border:
                          selectedPayment === "partial"
                            ? "none"
                            : "1px solid #ccc",

                        background:
                          selectedPayment === "partial" ? "#5a140c" : "#fff",

                        color:
                          selectedPayment === "partial" ? "#fff" : "#5a140c",

                        fontWeight: "600",

                        fontSize: isMobile ? "14px" : "15px",

                        cursor: "pointer",
                      }}
                    >
                      Partial
                    </button>

                    <button
                      onClick={() => setSelectedPayment("full")}
                      style={{
                        flex: 1,
                        height: isMobile ? "44px" : "48px",
                        borderRadius: "10px",
                        border:
                          selectedPayment === "full"
                            ? "none"
                            : "1px solid #ccc",

                        background:
                          selectedPayment === "full" ? "#5a140c" : "#fff",

                        color: selectedPayment === "full" ? "#fff" : "#5a140c",

                        fontWeight: "600",

                        fontSize: isMobile ? "14px" : "15px",

                        cursor: "pointer",
                      }}
                    >
                      Full
                    </button>
                  </div>

                  {/* NOTE */}

                  <div
                    style={{
                      background: "#f9f2ef",
                      border: "1px solid #eaded8",
                      borderRadius: "12px",
                      padding: isMobile ? "14px" : "16px",
                      marginBottom: isMobile ? "16px" : "20px",
                      lineHeight: isMobile ? "22px" : "26px",
                      color: "#666",
                      fontSize: isMobile ? "12.5px" : "14px",
                    }}
                  >
                    Secure payment powered by Razorpay. Your agreement will be
                    activated immediately after successful payment verification.
                  </div>

                  {/* PAY NOW */}

                  <button
                    onClick={handlePayment}
                    disabled={loading}
                    style={{
                      width: "100%",
                      height: isMobile ? "50px" : "56px",
                      border: "none",
                      background: "#5a140c",
                      color: "#fff",
                      borderRadius: "12px",
                      fontSize: isMobile ? "15px" : "17px",
                      fontWeight: "700",
                      cursor: "pointer",
                    }}
                  >
                    {loading
                      ? "Processing..."
                      : `Pay ₹${payableAmount.toLocaleString("en-IN")}`}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageTransition>
  );
}

export default AgreementPaymentView;